import React from 'react';
import { Truck } from 'lucide-react';

const EquipmentSection = ({ 
  equipment, 
  selectedEquipment, 
  onToggleEquipment, 
  onUpdateQuantity,
  isExpanded, 
  onToggle 
}) => {
  // Group equipment by category
  const getEquipmentByCategory = () => {
    const categories = {};
    equipment.forEach(item => {
      if (!categories[item.category]) {
        categories[item.category] = [];
      }
      categories[item.category].push(item);
    });
    return categories;
  };

  const isSelected = (itemId) => selectedEquipment.find(e => e.id === itemId);

  return (
    <div className="border-b pb-4">
      <button
        type="button"
        onClick={onToggle}
        className="flex items-center justify-between w-full text-left font-semibold text-[#1e3a5f] mb-3"
      >
        <span className="flex items-center gap-2">
          <Truck size={18} />
          Equipment ({selectedEquipment.length} selected)
        </span>
        <span className="text-sm text-gray-500">{isExpanded ? '−' : '+'}</span>
      </button>
      
      {isExpanded && (
        <div className="bg-gray-50 p-4 rounded-lg space-y-4 max-h-64 overflow-y-auto">
          {Object.entries(getEquipmentByCategory()).map(([category, items]) => (
            <div key={category}>
              <h4 className="font-medium text-gray-700 mb-2 capitalize">{category.replace(/_/g, ' ')}</h4>
              <div className="grid grid-cols-1 gap-2">
                {items.map((item) => {
                  const selected = isSelected(item.id);
                  return (
                    <div
                      key={item.id}
                      className={`p-3 rounded-lg border transition-all duration-200 ${
                        selected ? 'border-[#1e3a5f] bg-[#1e3a5f]/10' : 'border-gray-200 bg-white'
                      }`}
                    >
                      <div className="flex justify-between items-center">
                        <div 
                          className="flex-1 cursor-pointer"
                          onClick={() => onToggleEquipment(item)}
                        >
                          <p className="font-semibold text-sm">{item.name}</p>
                          {item.description && (
                            <p className="text-xs text-gray-500">{item.description}</p>
                          )}
                        </div>
                        {selected && (
                          <div className="flex items-center border rounded">
                            <button
                              type="button"
                              onClick={() => onUpdateQuantity(item.id, selected.quantity - 1)}
                              className="px-2 py-1 text-gray-600 hover:bg-gray-100"
                            >−</button>
                            <span className="px-2 text-sm">{selected.quantity}</span>
                            <button
                              type="button"
                              onClick={() => onUpdateQuantity(item.id, selected.quantity + 1)}
                              className="px-2 py-1 text-gray-600 hover:bg-gray-100"
                            >+</button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
          
          {equipment.length === 0 && (
            <p className="text-gray-500 text-sm text-center py-4">
              No equipment items available. Add items in Equipment management.
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default EquipmentSection;
